/**
 * MobileBottomSheet -- 모바일 바텀시트 편집 패널
 *
 * 섹션 선택 시 아래에서 올라오는 시트. 데스크톱에서는 숨김.
 */

import { EditorForm } from './EditorForm.js'
import type { AllSectionId } from './types.js'
import type { FlatInvitation } from '../../stores/invitationStore.js'
import styles from './MobileBottomSheet.module.css'

interface MobileBottomSheetProps {
  invitation: FlatInvitation
  activeSection: AllSectionId | null
  onClose: () => void
}

export function MobileBottomSheet({ invitation, activeSection, onClose }: MobileBottomSheetProps) {
  if (!activeSection) return null

  return (
    <>
      <div className={styles.backdrop} onClick={onClose} />
      <div className={styles.sheet}>
        <div className={styles.handle}>
          <div className={styles.handleBar} />
        </div>
        <EditorForm
          invitation={invitation}
          activeSection={activeSection}
        />
      </div>
    </>
  )
}
